import ApiResponse from "@/server/responses/ApiResponse";

export default class ApiResponse_GetDuelStats extends ApiResponse {

    // TODO : Add getters when data is clear.
}
